import React from 'react'
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      '@media(max-width: 1050px)': {
        width: '100%',
        marginLeft: 0
      }
    },
    bottomBar: {
      top: 'unset',
      bottom: 0,
      backgroundColor: '#f0f0f7',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,}),
      },
      defaultBottomBar: {
        minHeight: '158px',
        '@media (max-width: 1050px)': {
          minHeight: 'unset',
        }
    },
    smallBottomBar: {
      minHeight: '88px',
        '@media (max-width: 1050px)': {
          minHeight: 'unset',
        }
    },
    topBarWrapper: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    bottomToolBar: {
        height: '100%',
        '@media (max-width: 1050px)': {
          padding: '0'
        }
    }
  }));

const TopAndBottomBar = ({ topBar, bottomBar, open, children, smallBar }) => {
    const classes = useStyles();

    if(topBar) return (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
            })}>
            <Toolbar className={classes.topBarWrapper}>
                {children}
            </Toolbar>
        </AppBar>
    )

    if(bottomBar) return (
        <AppBar
            position="fixed"
            className={clsx(classes.bottomBar, {
            [classes.appBarShift]: open,
            })}
        >
            <Toolbar className={`${classes.bottomToolBar} ${smallBar ? classes.smallBottomBar : classes.defaultBottomBar}`}>
                { children }
            </Toolbar>
        </AppBar>
    )
}

TopAndBottomBar.defaultProps = {
    topBar: false,
    bottomBar: false,
    smallBar: false
}

export default TopAndBottomBar